<template>
    <b-container fluid="true" class="py-3">
        <b-row no-gutters>
            <b-col order="2" order-sm="1" cols="12">
                <b-row no-gutters v-if="getDamInclinometersNew">
                        <ChartColumnWrapper
                            v-for="(activeItem, index) in availableInclinometers"
                            :active-item="activeItem"
                            :key="`aig-${index}`"
                        ></ChartColumnWrapper>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    // utils
    import {mapGetters} from "vuex";
    // mixins
    import chartSafeTooltipMixin from "../../mixins/chartSafeTooltipMixin";
    import chartContainerMixinOnly from "../../mixins/chartContainerMixinOnly";
    // constants
    import {
        INCLINOMETER,
        defaultMeasuringProfile,
        doNotShowTripleData
    } from "../../constants/chart-constants";
    import {
        autoStartTimeFrame,
        autoStartSensors,
        sensorsGraphics,
        iconsUnits,
        showPlotLineFor
    } from "../../constants/sensors-constants";
    // components
    import ChartColumnWrapper from "./ChartColumnWrapper";

    /**
     * Container for 2 inclinometers charts. This is one tab's content.
     * There are 4 in total.
     * First chart shows X axis, second shows Y axis
     */

    export default {
        name: "ChartInclinometersContainer",
        mixins: [chartSafeTooltipMixin, chartContainerMixinOnly],
        components: {
            ChartColumnWrapper
        },
        data() {
            return {
                sensorsGraphics,
                iconsUnits,
                containsMultiChartItem: true,
                tabTitle: "sensors-page.inclinometers.tab-title"
            }
        },
        computed: {
            // getDamInclinometers returns dict original data and array with sorted keys
            ...mapGetters(['getDamInclinometersNew', 'getSiteUniqueSensors']),
            /**
             * Need to check the sensor keys from BE as to determine
             * what we exactly have: normal or vw
             */
            realSensorKey() {
                let realKey = INCLINOMETER;

                for (let key of this.getSiteUniqueSensors) {
                    if (key.toLowerCase().includes(realKey.toLowerCase())) {
                        realKey = key;
                        break;
                    }
                }

                return realKey;
            },
            /**
             *
             * @returns {[]} Piezometers info with refined structure
             */
            availableInclinometers() {
                const inclinometerXY = ['X', 'Y'];
                const availableInclinometers = [];

                for (let index = 0; index < 2; index++) {
                    // for inclinometers we need two charts - inclination per X and per Y
                    // the second is for Y, so it is an alternative - BE will return Y data
                    // NOTE: alternative: since we need only 2 charts, a simple switch is used
                    availableInclinometers.push({
                        name: this.realSensorKey,
                        title: `${this.$i18n.t('sensors-page.inclinometers.inclinometer-title')} ${inclinometerXY[index]}`,
                        value: '',
                        metric: this.iconsUnits[INCLINOMETER].unit || '',
                        icon: this.iconsUnits[INCLINOMETER].icon || '',
                        alternative: index !== 0,
                        autoStart: autoStartSensors.includes(this.realSensorKey),
                        autoStartTimeFrame: autoStartTimeFrame,
                        showTripleData: doNotShowTripleData,
                        showPlotLine: showPlotLineFor.includes(this.realSensorKey),
                        measuringProfile: defaultMeasuringProfile,
                        containsMultiChartItem: this.containsMultiChartItem
                    });
                }

                return availableInclinometers;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";
    @import "../../assets/scss/mixins";
</style>